import React, { useContext, useEffect, useState } from 'react';
import ContextStates from '../context/ContextStates';

const FooterVenta = () => {
    const [total, setTotal] = useState(0);
    const {
        venta, setFormView, setViewOpen, precio, presupuesto,
        porcentajeDesc, descAux, setDescAux, setPorcentajeDesc,
        totalDesc, setTotalDesc
    } = useContext(ContextStates);

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            if (venta && venta.length > 0) {
                venta.forEach(element => {
                    if (!precio) {
                        if (element.tipopromo === '1' || element.tipopromo === '2') {
                            aux += parseFloat(element.preciopromocion * element.cantidad);
                        } else if (element.tipopromo === '3') {
                            let precioLinea = 0;
                            if (element.cantidad >= element.cantidadminima) {
                                // mejor usar división entera para “paga X lleva Y”
                                const cantPromos = Math.floor(parseFloat(element.cantidad) / parseFloat(element.cantidadminima));
                                const cantPagos = parseFloat(element.cantidad) - (parseFloat(element.cantidaddescuento) * cantPromos);
                                precioLinea = cantPagos * parseFloat(element.precio);
                            } else {
                                precioLinea = parseFloat(element.cantidad) * parseFloat(element.precio);
                            }
                            aux += precioLinea;
                        } else {
                            aux += parseFloat(element.precio * element.cantidad);
                        }
                    } else {
                        aux += parseFloat(element.preciopormayor * element.cantidad);
                    }
                });
                setTotal(aux || 0);
            } else {
                setTotal(0);
            }
        };
        calcTotal();
    }, [venta, precio]);

    useEffect(() => {
        if (total > 0 && descAux !== '') {
            setTotalDesc(total - (total * parseFloat(descAux) / 100));
        } else if (total > 0 && porcentajeDesc !== '') {
            setTotalDesc(total - (total * parseFloat(porcentajeDesc) / 100));
        }
    }, [total, descAux, porcentajeDesc, setTotalDesc]);

    const finalizarVenta = () => {
        if (total > 0) {
            setFormView(2);
            setViewOpen(true);
        }
    };

    const handleDesc = (val) => {
        if ((parseFloat(val) > 0 && parseFloat(val) <= 100) || val === '') {
            setPorcentajeDesc(val);
            setDescAux(val);
        }
    };

    return (
        <>
            {/* Espaciador para que el contenido no quede tapado por el footer fijo */}
            <div className="h-28" aria-hidden />

            {/* Footer fijo */}
            <div className="fixed inset-x-0 bottom-0 z-50 bg-white/90 backdrop-blur border-t">
                <div className="mx-auto max-w-7xl p-4">
                    <div className="grid grid-cols-3 items-center gap-4">
                        <div className="flex items-center gap-2">
                            <label htmlFor="porcentajeDesc" className="font-medium">Descuento (%)</label>
                            <input
                                id="porcentajeDesc"
                                type="number"
                                className="no-spinner w-24 px-2 py-1 rounded border"
                                value={porcentajeDesc}
                                onChange={(e) => handleDesc(e.target.value)}
                            />
                        </div>

                        <div className="text-center">
                            <p className="font-medium text-2xl">
                                Total: <span className="font-bold">
                                    $ {total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                </span>
                            </p>
                            {porcentajeDesc !== '' && total !== 0 && (
                                <p className="font-medium text-lg">
                                    Total con descuento:{' '}
                                    <span className="font-bold text-green-600">
                                        $ {totalDesc.toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                    </span>
                                </p>
                            )}
                        </div>

                        <div className="text-right">
                            <button
                                type="button"
                                className={`w-full p-3 text-white uppercase font-semibold rounded ${total > 0 ? 'bg-orange-500 hover:bg-orange-600' : 'bg-orange-200 cursor-not-allowed'
                                    }`}
                                onClick={finalizarVenta}
                                disabled={total <= 0}
                            >
                                {presupuesto ? 'Finalizar Presupuesto' : 'Finalizar venta'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterVenta;